import { typesApp } from './typesModuleApp';

export const mutations = {
  [typesApp.mutations.SET_IS_POSTING](state, isPosting) {
    state.isPosting = isPosting;
  },
  [typesApp.mutations.SET_RECAPTCHA_ID](state, RECAPTCHA_ID) {
    state.RECAPTCHA_ID = RECAPTCHA_ID;
  },
};

export default {};
